import React from 'react';

const WhyUs = () => {
  return (
    <section id="why-us" class="why-us section">
      <div class="container section-title" data-aos="fade-up">
        <h2>Why Us</h2>
        <p>AI that acts. Automation that scales. Design that converts. Marketing that moves.
          That’s not the future — that’s Autobotics.</p>
      </div>
      <div class="container" data-aos="fade-up" data-aos-delay="100">
        <div class="row g-4">
          <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div class="feature-card">
              <div class="icon-wrapper">
                <i class="bi bi-palette-fill"></i>
              </div>
              <h4>Creative Excellence</h4>
              <p>We fuse creativity with intelligence — crafting designs and digital experiences that inspire, engage, and drive measurable growth.</p>
              <div class="feature-stats">
                <span class="stat-number" data-purecounter-start="0" data-purecounter-end="95" data-purecounter-duration="2">95</span>
                <span class="stat-label">% Client Satisfaction</span>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
            <div class="feature-card">
              <div class="icon-wrapper">
                <i class="bi bi-graph-up-arrow"></i>
              </div>
              <h4>Proven Results</h4>
              <p>We don’t just promise — we measure. Every automation, every design, every campaign is backed by data, driven by strategy, and built to deliver tangible results.</p>
              <div class="feature-stats">
                <span class="stat-number" data-purecounter-start="0" data-purecounter-end="200" data-purecounter-duration="2">300</span>
                <span class="stat-label">% ROI Increase</span>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
            <div class="feature-card">
              <div class="icon-wrapper">
                <i class="bi bi-award-fill"></i>
              </div>
              <h4>Expert Team</h4>
              <p>Our team is a mix of creators and problem-solvers who live and breathe technology. From AI experts and automation architects to design and marketing specialists — we collaborate to deliver solutions that are as smart as they are impactful.</p>
              <div class="feature-stats">
                <span class="stat-number" data-purecounter-start="0" data-purecounter-end="50" data-purecounter-duration="2">21</span>
                <span class="stat-label">+ Awards Won</span>
              </div>
            </div>
          </div>

        </div>

        <div class="row mt-5">
          <div class="col-lg-6" data-aos="fade-right" data-aos-delay="200">
            <div class="feature-showcase">
              <img src="assets/img/illustration/illustration-14.webp" alt="Creative Process" class="img-fluid"></img>
            </div>
          </div>

          <div class="col-lg-6" data-aos="fade-left" data-aos-delay="300">
            <div class="feature-content">
              <h3>Why Leading Brands Choose Us</h3>
              <p class="lead">.. because we don’t sell services — we build partnerships. We understand your goals, design intelligent solutions around them, and deliver results that speak louder than words.</p>

              <div class="feature-list">
                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="bi bi-check-circle-fill"></i>
                  </div>
                  <div class="feature-text">
                    <h5>Strategic Thinking</h5>
                    <p>We don’t just execute — we think ahead. Every project begins with a clear strategy that aligns technology with business goals, ensuring long-term growth and sustainability.</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="bi bi-check-circle-fill"></i>
                  </div>
                  <div class="feature-text">
                    <h5>Quality You Can Trust</h5>
                    <p>As an ISO 9001:2015 certified company, we follow global standards to ensure precision, reliability, and excellence in every project.</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="bi bi-check-circle-fill"></i>
                  </div>
                  <div class="feature-text">
                    <h5>24/7 Support</h5>
                    <p>Your systems never sleep — and neither do we. Our dedicated support team ensures smooth operations, quick responses, and round-the-clock assistance whenever you need it.</p>
                  </div>
                </div>
              </div>

              <div class="cta-wrapper">
                <a href="#ScheduleCall" class="btn btn-primary">Start Your Project</a>
                {/* <a href="#" class="btn btn-outline">View Portfolio</a> */}
              </div>
            </div>
          </div>
        </div>

      </div>

    </section>

  );
};

export default WhyUs;
